<template>
  <v-chip
    :small="small"
    :x-small="xSmall"
    :class="[badgeConfig.chipClass, 'font-weight-bold elevation-0 border-chip']"
  >
    <v-icon left small v-if="showIcon" :color="badgeConfig.iconColor">
      {{ badgeConfig.icon }}
    </v-icon>
    <span>{{ badgeConfig.label }}</span>
  </v-chip>
</template>

<script>
export default {
  name: "CategoryBadge",
  props: {
    tipo: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: true,
    },
    xSmall: {
      type: Boolean,
      default: false,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    badgeConfig() {
      const type = (this.tipo || "").toLowerCase();
      switch (type) {
        case "feat":
        case "feature":
        case "recurso":
        case "adicionado":
          return {
            chipClass: "badge-feat",
            iconColor: "var(--cb-feat-texto)",
            icon: "mdi-sparkles",
            label: "Recursos & Adicionados",
          };
        case "fix":
        case "correcao":
        case "bug":
          return {
            chipClass: "badge-fix",
            iconColor: "var(--cb-fix-texto)",
            icon: "mdi-bug-outline",
            label: "Correções & Bugs",
          };
        case "refactor":
        case "refatoracao":
        case "perf":
          return {
            chipClass: "badge-refactor",
            iconColor: "var(--cb-refactor-texto)",
            icon: "mdi-tune-vertical",
            label: "Refatorações & Performance",
          };
        case "style":
        case "ui":
        case "estilo":
          return {
            chipClass: "badge-style",
            iconColor: "var(--cb-style-texto)",
            icon: "mdi-palette-outline",
            label: "Interface & Estilo",
          };
        default:
          return {
            chipClass: "badge-chore",
            iconColor: "var(--cb-chore-texto)",
            icon: "mdi-tools",
            label: "Manutenção & Outros",
          };
      }
    },
  },
};
</script>

<style scoped>
.border-chip {
  /* Tons de cada categoria (claro) */
  --cb-feat-fundo: #ccfbf1;
  --cb-feat-borda: #99f6e4;
  --cb-feat-texto: #0f766e;
  --cb-fix-fundo: #ffe4e6;
  --cb-fix-borda: #fecdd3;
  --cb-fix-texto: #be123c;
  --cb-refactor-fundo: #e0e7ff;
  --cb-refactor-borda: #c7d2fe;
  --cb-refactor-texto: #4338ca;
  --cb-style-fundo: #fce7f3;
  --cb-style-borda: #fbcfe8;
  --cb-style-texto: #be185d;
  --cb-chore-fundo: var(--surface-3);
  --cb-chore-borda: #cbd5e1;
  --cb-chore-texto: var(--text-3);
  border-width: 1px !important;
  border-style: solid !important;
}

/* Tons de cada categoria (escuro) */
.theme--dark .border-chip {
  --cb-feat-fundo: rgba(20, 184, 166, 0.16);
  --cb-feat-borda: rgba(45, 212, 191, 0.35);
  --cb-feat-texto: #5eead4;
  --cb-fix-fundo: rgba(244, 63, 94, 0.16);
  --cb-fix-borda: rgba(251, 113, 133, 0.35);
  --cb-fix-texto: #fda4af;
  --cb-refactor-fundo: rgba(99, 102, 241, 0.18);
  --cb-refactor-borda: rgba(129, 140, 248, 0.4);
  --cb-refactor-texto: #a5b4fc;
  --cb-style-fundo: rgba(236, 72, 153, 0.16);
  --cb-style-borda: rgba(244, 114, 182, 0.35);
  --cb-style-texto: #f9a8d4;
  --cb-chore-borda: var(--border);
}

.badge-feat {
  background-color: var(--cb-feat-fundo) !important;
  border-color: var(--cb-feat-borda) !important;
  color: var(--cb-feat-texto) !important;
}

.badge-fix {
  background-color: var(--cb-fix-fundo) !important;
  border-color: var(--cb-fix-borda) !important;
  color: var(--cb-fix-texto) !important;
}

.badge-refactor {
  background-color: var(--cb-refactor-fundo) !important;
  border-color: var(--cb-refactor-borda) !important;
  color: var(--cb-refactor-texto) !important;
}

.badge-style {
  background-color: var(--cb-style-fundo) !important;
  border-color: var(--cb-style-borda) !important;
  color: var(--cb-style-texto) !important;
}

.badge-chore {
  background-color: var(--cb-chore-fundo) !important;
  border-color: var(--cb-chore-borda) !important;
  color: var(--cb-chore-texto) !important;
}
</style>
